export function setupHeader() {
    const menu = document.querySelector('#hamburger-menu');

    function handleTouchEvents() {
        const header = $('header nav');
        if (header.hasClass('open')) {
            header.removeClass('open');
        } else {
            header.addClass('open');
        }
    }

    menu.addEventListener('touchStart', handleTouchEvents)
}

